import { h } from 'preact'
import Error from './Error'
import { CampaignType } from 'scripts/type'
import { getCampaignTypeName } from 'scripts/utils'

export default function Closed({ campaignType }: { campaignType: CampaignType }) {
  return <Error title={`该${getCampaignTypeName(campaignType)}已关闭链接访问填写。`} code="closed" />
}
